import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/testOps.ts
const createTestUserInputSchema = z.object({ username: z.string().optional() });
const createTestUserOutputSchema = z.object({
	userId: z.string(),
	token: z.string()
});
const testOpsContract = oc.prefix("/test-ops").tag("TestOps").router({ createTestUser: oc.route({
	method: "POST",
	path: "/create-test-user"
}).input(createTestUserInputSchema).output(createTestUserOutputSchema).errors({ FORBIDDEN: {
	status: 403,
	message: "createTestUser disabled in production"
} }) });
//#endregion
export { testOpsContract };
